let onError;
let onNotification
let onLoad;

const setOnError = (onErr) => {
    onError=onErr;
}

const executeError = (error) => {    
    onError(error)
}

const setOnNotification = (onNotif) => {
    onNotification=onNotif;
}

const addNotification = (notification) => {
    //{ title:"T", body:"B", autohide: 5000, closeButton, fade }
    onNotification(notification);
}

const setOnLoad = (onLoading) => {
    onLoad = onLoading
}

const load = (loading) => {    
    onLoad(loading)
}

export {setOnError, executeError, setOnNotification, addNotification, setOnLoad, load}

